export const GET_STYLES = 'styles/GET_STYLES';
export const GET_STYLES_SUCCESS = 'styles/GET_STYLES_SUCCESS';
export const GET_STYLES_ERROR = 'styles/GET_STYLES_ERROR';
